import { render, staticRenderFns } from "./AnimationModal.vue?vue&type=template&id=554401b2&scoped=true&"
import script from "./AnimationModal.vue?vue&type=script&lang=js&"
export * from "./AnimationModal.vue?vue&type=script&lang=js&"
import style0 from "./AnimationModal.vue?vue&type=style&index=0&id=554401b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554401b2",
  null
  
)

export default component.exports